var primarycolor = getComputedStyle(document.body).getPropertyValue('--vs-primary');
var bordercolor = getComputedStyle(document.body).getPropertyValue('--bordercolor');
var bodycolor = getComputedStyle(document.body).getPropertyValue('--bodycolor');
export default [
    {
        mainbarchart:
        {
            data: {
                labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                datasets: [{
                    label: 'Investment',
                    backgroundColor: [
                        '#1e3d73',
                        '#1e3d73',
                        '#1e3d73',
                        '#1e3d73',
                        '#1e3d73',
                        '#1e3d73',
                        '#1e3d73',
                        '#1e3d73',
                        '#1e3d73',
                        '#1e3d73',
                        '#1e3d73',
                        '#1e3d73'
                    ],
                    data: [35, 55, 75, 95, 115, 135, 155, 175, 195, 215, 235, 250]
                }]
            },
            options: {
                sive: true,
                legend: {
                    display: false,
                    position: 'top',
                    labels: {
                        fontColor: bodycolor
                    }
                },
                scales: {
                    xAxes: [{
                        display: true,
                        maxBarThickness: 10,
                        gridLines: {
                            display: true,
                            color: bordercolor,
                            zeroLineColor: bordercolor
                        },
                        ticks: {
                            fontColor: bodycolor,
                        },
                    }],
                    yAxes: [{
                        type: 'linear', // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
                        display: false,
                        position: 'left',
                        id: 'y-axis-2',
                        gridLines: {
                            drawOnChartArea: false,
                            color: bordercolor,
                            zeroLineColor: bordercolor
                        },
                        ticks: {
                            fontColor: bodycolor,
                        }
                    }, {
                        display: true,
                        gridLines: {
                            display: true,
                            color: bordercolor,
                            zeroLineColor: bordercolor
                        },
                        ticks: {
                            fontColor: bodycolor,
                        }
                    }]
                }

            }
        },
        investment:
        {
            options: {

                grid: {
                    show: false,
                    padding: {
                        left: 0,
                        right: 0
                    }
                },
                chart: {
                    toolbar: {
                        show: false,
                    },
                    sparkline: {
                        enabled: true
                    }
                },
                colors: ['#1e3d73', '#6e63dc', '#635bb5', '#615b9a'],
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    curve: 'smooth'
                },
                xaxis: {
                    type: 'numeric',
                    lines: {
                        show: false,
                    },
                    axisBorder: {
                        show: false,
                    },

                    labels: {
                        show: false,
                    },
                },
                yaxis: [{
                    y: 0,
                    offsetX: 0,
                    offsetY: 0,
                    padding: {
                        left: 0,
                        right: 0
                    },
                }],
                tooltip: {
                    x: {
                        show: false,
                        format: 'dd/MM/yy HH:mm'
                    },
                },



            },
            series: [
                {
                    data: [11, 32, 45, 32, 34, 52, 41],
                },
            ],
        },
        profit:
        {
            options: {

                grid: {
                    show: false,
                    padding: {
                        left: 0,
                        right: 0
                    }
                },
                chart: {
                    toolbar: {
                        show: false,
                    },
                    sparkline: {
                        enabled: true
                    }
                },
                colors: ['#28a745', '#37ad52', '#4ac165', '#5fca77', '#7ed492'],
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    curve: 'smooth'
                },
                xaxis: {
                    type: 'numeric',
                    lines: {
                        show: false,
                    },
                    axisBorder: {
                        show: false,
                    },

                    labels: {
                        show: false,
                    },
                },
                yaxis: [{
                    y: 0,
                    offsetX: 0,
                    offsetY: 0,
                    padding: {
                        left: 0,
                        right: 0
                    },
                }],
                tooltip: {
                    x: {
                        show: false,
                        format: 'dd/MM/yy HH:mm'
                    },
                },



            },
            series: [
                {
                    data: [11, 32, 45, 32, 34, 52, 41],
                },
            ],
        },
        stats:
        {
            options: {

                grid: {
                    show: false,
                    padding: {
                        left: 0,
                        right: 0
                    }
                },
                chart: {
                    toolbar: {
                        show: false,
                    },
                    sparkline: {
                        enabled: true
                    }
                },
                colors: ['#17a2b8', '#d43f4d', '#da5965', '#de6f79', '#e88790'],
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    curve: 'smooth'
                },
                xaxis: {
                    type: 'numeric',
                    lines: {
                        show: false,
                    },
                    axisBorder: {
                        show: false,
                    },

                    labels: {
                        show: false,
                    },
                },
                yaxis: [{
                    y: 0,
                    offsetX: 0,
                    offsetY: 0,
                    padding: {
                        left: 0,
                        right: 0
                    },
                }],
                tooltip: {
                    x: {
                        show: false,
                        format: 'dd/MM/yy HH:mm'
                    },
                },



            },
            series: [
                {
                    data: [11, 32, 45, 32, 34, 52, 41],
                },
            ],
        },
    }
]
